import { render } from "./TazAdmin.vue?vue&type=template&id=380e6d2a&ts=true"
import script from "./TazAdmin.vue?vue&type=script&lang=ts"
export * from "./TazAdmin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__